<template>
  <div class="waitingcallMessage">
    <div v-if="status">
      <div class="title mb30">
        <h2 v-if="infoData && infoData.title[ln]" class="preWrap">{{ infoData && infoData.title[ln] }}</h2>
        <h2 v-else class="notranslate">{{ locale.check_waiting }}</h2>
        <p v-if="infoData && infoData.desc[ln]" class="preWrap">{{ infoData && infoData.desc[ln] }}</p>
        <p v-else class="preWrap notranslate">{{ locale.waiting_entered_info }}</p>
      </div>
      <div class="formBox">
        <div class="info mb notranslate">
          <div v-if="waitingNum" class="waitingNum">{{ locale.waiting_number }} {{ waitingNum }}</div>
          <dl v-if="name"><dt>{{ locale.name }}</dt><dd>{{ name }}</dd></dl>
          <dl v-if="phone"><dt>{{ locale.telephone }}</dt><dd>{{ phone }}</dd></dl>
          <dl v-if="email"><dt>{{ locale.email }}</dt><dd>{{ email }}</dd></dl>
        </div>
        <div class="status">
          <div v-if="statusMessage.infoData" class="statusMessage preWrap">{{ statusMessage.infoData }}</div>
          <div v-else class="statusMessage preWrap notranslate">{{ statusMessage.message }}</div>
          <div class="statusList notranslate">
            <div
              v-for="item in statusList"
              :key="item.id"
              :class="{active: item.active}"
              class="item">
              <span class="label">{{ getStatusMessage(item.id) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="message" class="notranslate">
      <div class="title mb30">
        <h2>{{ message }}</h2>
      </div>
    </div>
    <div v-else class="notranslate">
      <div class="title mb30">
        <h2>{{ locale.loading_waitingcall }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'ln',
    'locale',
    'isPublic',
    'result',
    'info',
    'spaceCodeName'
  ],
  computed: {
    infoData () {
      return this.info && this.info.status
    },
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    rid () {
      return this.$route.params.rid
    },
    statusMessage () {
      const status = this.status
      const remainWaitingNum = this.remainWaitingNum
      let message = ''
      switch (status) {
        case 'wait':
          message = this.locale.status_waiting_ing
          break
        case 'assign':
          message = this.locale.status_ready_ing
          break
        case 'call':
          message = this.locale.status_called
          break
        case 'complete':
          message = this.locale.status_completed
          break
      }
      function replaceVar (str, vars, spaceCodeName) {
        return str.replace('{var}', vars).replace('{spaceCodeName}', spaceCodeName)
      }
      return {
        infoData: this.infoData && replaceVar(this.infoData[`message${status.toUpperCase()}`][this.ln], remainWaitingNum, this.spaceCodeName),
        message: message
      }
    }
  },
  async created () {
    const spaceCode = this.spaceCode
    const rid = this.rid
    if (spaceCode && rid) {
      const data = {
        spaceCode: spaceCode,
        rid: rid
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('waitingcall/getWaitingcallStatus', data).then((res) => {
        if (res && res.status && res.status === 200) {
          const sendResult = res.data && res.data.message
          if (sendResult && sendResult.currentStatus) {
            const status = sendResult.currentStatus
            this.status = status.toLowerCase()
            this.name = sendResult.name === 'UNKNOWN' ? ' ' : sendResult.name
            this.phone = sendResult.phone
            this.email = sendResult.email
            this.waitingNum = sendResult.waitingNum
            this.remainWaitingNum = sendResult.remainWaitingNum || 0
            this.statusList = this.statusList.map(x => {
              return {
                ...x,
                active: x.status.includes(status)
              }
            })
            this.$store.commit('loading', false)
          } else {
            const errorCode = res && res.message && res.message.code || 500
            const errorMessage = this.getResultData(errorCode)
            const reason = res && res.message && res.message.reason
            this.message = this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : '')
            this.$store.commit('loading', false)
          }
        } else {
          const errorCode = res && res.message && res.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          const reason = res && res.message && res.message.reason
          this.message = this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : '')
          this.$store.commit('loading', false)
        }
      })
    } else {
      alert(this.locale.access_correct_path)
    }
  },
  data () {
    return {
      status: null,
      statusList: [
        { id: 'wait', status: ['WAIT'], active: false, label: this.locale.status_wait },
        { id: 'assign-call', status: ['ASSIGN', 'CALL'], active: false, label: this.locale.status_progress },
        { id: 'complete', status: ['COMPLETE'], active: false, label: this.locale.status_complete }
      ],
      name: null,
      phone: null,
      email: null,
      waitingNum: null,
      remainWaitingNum: 0,
      message: null
    }
  },
  methods: {
    getStatusMessage (status) {
      return this.locale[`waiting_status_${status}`]
    },
    getResultData (code) {
      return this.$store.getters['waitingcall/getWaitingcallResultData'](code)
    }
  }
}
</script>

